import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

const SocialLink = ({ href, icon }) => (
  <a
    href={href || '#'}
    target={href ? '_blank' : undefined}
    rel="noopener noreferrer"
    className={cx({ disabled: !href })}
  >
    <i className={`${icon} m-r-xs`} />
  </a>
);

const KeyContacts = ({ contacts }) => (
  <div>
    <h3 className="text-md m-b">Key Contacts ({contacts.length})</h3>
    <div className="scroll-shadow-container">
      <div className="key-contacts">
        {contacts.map((employee) => (
          <div
            key={`${employee.full_name}-${employee.email || ''}`}
            className="contact-card card card-sm d-flex flex-items-xxs-middle"
          >
            <div
              className="img-circle m-r flex-xxs-top flex-no-shrink"
              style={{ backgroundImage: `url(${employee.logo_url})` }}
            />
            <div className="contact-info">
              <a
                href={employee.cb_url || '#'}
                target={employee.cb_url ? '_blank' : undefined}
                rel="noopener noreferrer"
                className={cx('text-bold text-sm d-block m-b-xxxs', {
                  disabled: !employee.cb_url,
                })}
              >
                {employee.full_name}
              </a>
              <p>
                <b>Title:&nbsp;</b>
                {employee.title || <span className="text-muted">Not Available</span>}
              </p>
              <p className="m-b-xs">
                <b>Email:&nbsp;</b>
                {employee.email || <span className="text-muted">Not Available</span>}
              </p>
              <div className="text-md social-links l-h-xxs">
                <SocialLink href={employee.facebook_url} icon="hicon-facebook" />
                <SocialLink href={employee.twitter_url} icon="hicon-social-x-square" />
                <SocialLink href={employee.linkedin_url} icon="hicon-linkedin" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

KeyContacts.propTypes = {
  contacts: T.array.isRequired,
};

export default KeyContacts;
